import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { journeyHandler } from 'rp-popup';
import { mobileDetect } from 'rp-gui-guide';
import Select from '../../../shared/Select';
import NameContainer from './NameContainer';
import { buildProfileUrl } from '../../../utils/url';

class RunnerSelect extends PureComponent {
    onChange = (val) => {
        const selectedRunner = this.props.runners[+val];
        const url = buildProfileUrl(selectedRunner.horseUid, selectedRunner.horseName, 'horse');
        const urlToRedirect = `${url}#race-id=${selectedRunner.raceInstanceUid}`;

        if (mobileDetect.mobile()) {
            journeyHandler.trackJourney(urlToRedirect);
        }
        window.location.href = urlToRedirect;
    }

    render() {
        const { runners, selectedHorseIndex } = this.props;
        const { horseName, countryOriginCode, startNumber } = runners[selectedHorseIndex];

        const options = runners.map(r =>
            `${r.startNumber}. ${r.horseName} (${r.countryOriginCode})`
        );

        return (
            <Select
                value={selectedHorseIndex}
                options={options}
                onSelect={this.onChange}
                wrapperClass="pp-select_runners ui-btn_hollow"
            >
                <NameContainer
                    horseName={horseName}
                    countryCode={countryOriginCode}
                    number={startNumber}
                />
            </Select>
        );
    }
}

RunnerSelect.propTypes = {
    runners: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.objectOf(
            PropTypes.shape({
                horseName: PropTypes.string.isRequired,
                horseUid: PropTypes.number.isRequired,
                raceInstanceUid: PropTypes.number.isRequired,
                countryOriginCode: PropTypes.string.isRequired,
                startNumber: PropTypes.number.isRequired,
            })
        ),
    ]),
    selectedHorseIndex: PropTypes.number.isRequired,
};

export default RunnerSelect;



// WEBPACK FOOTER //
// ./src/js/horse/nameRow/components/RunnerSelect.jsx